import { render } from "./BaseSpacer.vue?vue&type=template&id=6abf71d9"
import script from "./BaseSpacer.vue?vue&type=script&lang=js"
export * from "./BaseSpacer.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__